import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Proc() {
	const qs = require('qs');
	const navigate = useNavigate();

	const getItem = (key) => {
		const item = localStorage.getItem(key);
		if (!item) navigate('/login');
		else return localStorage.getItem(key);
	};
	const menuList = [
		{
			index: '01',
			menu: [
				{
					name: '허브',
					pageDesc: '상품데이터 관리 페이지',
					func: () => goPage('/hub'),
				},
				{
					name: '주문목록',
					pageDesc: '주문데이터 관리 페이지',
					func: () => goPage('/order'),
				},
				{
					name: '스케쥴러',
					pageDesc: '스케쥴 관리 페이지',
					func: () => goPage('/cron'),
				},
			],
		},
		{
			index: '02',
			menu: [
				// {
				// 	name: '상품공급',
				// 	pageDesc: '페이지 설명',
				//	func: ()=>goPage('/provide'),
				// },
				{
					name: '상품수집',
					pageDesc: '도매사 상품데이터를 수집하는 기능',
					func: () => glean('sync'),
				},
				{
					name: '주문수집',
					pageDesc: '오픈마켓 주문데이터를 수집하는 기능',
					func: () => spread('collect'),
				},
				{
					name: '송장수집',
					pageDesc: '도매사 송장데이터를 수집하는 기능',
					func: () => glean('delivery'),
				},
			],
		},
		{
			index: '03',
			menu: [
				{
					name: '상품등록',
					pageDesc: '수집한 상품데이터를 오픈마켓에 등록하는 기능',
					func: () => goPage('/market'),
				},
				{
					name: '상품갱신',
					pageDesc: '수집한 상품데이터를 오픈마켓에 연동시키는 기능',
					func: () => spread('update'),
				},

				{
					name: '자동발주',
					pageDesc: '수집한 주문데이터를 발주하는 기능',
					func: () => glean('order'),
				},
			],
		},
	];

	const spread = (mode) => {
		if (window.confirm(mode + ' 실행 하시겠습니까?')) {
			for (const marketCode of ['smartstore', 'coupang', 'eleventh', 'kbpay', 'imembers', 'showdam', 'aphrozone']) {
				axios
					.post(
						`${window.location.protocol}//${window.location.hostname}:3001/spread`,
						qs.stringify({
							token: getItem('token'),
							mode,
							marketCode,
						})
					)
					.then((res) => {
						console.log(res);
					})
					.catch();
			}
		}
	};

	const glean = (mode) => {
		if (window.confirm(mode + ' 실행 하시겠습니까?')) {
			axios({
				method: 'POST',
				url: `${window.location.protocol}//${window.location.hostname}:3001/glean`,
				data: {
					token: getItem('token'),
					mode,
					vendorCode: 'all'
				},
				xhrFields: {
					withCredentials: true,
				},
			})
				.then((res) => {
					console.log(res);
				})
				.catch();
		}
	};
	const goPage = (path) => {
		navigate(path);
	};

	// 페이지 렌더링 후 가장 처음 호출되는 함수
	useEffect(
		() => {
			if (!localStorage.getItem('token')) goPage('/login');
			else {
				axios
					.post(
						`${window.location.protocol}//${window.location.hostname}:3001/check`,
						qs.stringify({
							token: localStorage.getItem('token'),
						})
					)
					.then((res) => {
						if (res.data.expired) {
							localStorage.removeItem('token');
							goPage('/login');
						}
					})
					.catch();
			}
		},
		// 페이지 호출 후 처음 한번만 호출될 수 있도록 [] 추가
		[]
	);

	return (
		<>
			<div className='proc'>
				<h2>Process</h2>
				{menuList.map((obj, index) => {
					return (
						<div className='procBox' key={index}>
							<h3>{obj.index}</h3>
							{obj.menu.map((menu, index) => {
								return (
									<button type='button' onClick={menu.func} key={index}>
										<div className='button-title'>
											<div className='button-title-left'>
												{/* <img src={menuIcon} alt='' /> */}
												<svg
													width='18'
													height='18'
													x='9'
													y='9'
													viewBox='0 0 210 210'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'
												>
													<rect
														x='6'
														y='9'
														width='76'
														height='76'
														rx='16'
														stroke='#0000006c'
														strokeWidth='12'
													/>
													<rect
														x='104'
														y='9'
														width='76'
														height='76'
														rx='16'
														stroke='#0000006c'
														strokeWidth='12'
														className='special-rotate'
													/>
													<rect
														x='6'
														y='108'
														width='76'
														height='76'
														rx='16'
														stroke='#0000006c'
														strokeWidth='12'
													/>
													<rect
														x='104'
														y='108'
														width='76'
														height='76'
														rx='16'
														stroke='#0000006c'
														strokeWidth='12'
													/>
												</svg>
												{menu.name}
											</div>
											<span></span>
										</div>
										<p>{menu.pageDesc}</p>
									</button>
								);
							})}
						</div>
					);
				})}
			</div>
		</>
	);
}

export default Proc;
